export default "__VITE_PUBLIC_ASSET__d8e3746d__"